// Language & location
export const LanguageJP = "ja-JP";
export const LocaleJP = "ja";

// Environment
//const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const ApiSite = process.env.REACT_APP_API_SITE;
export const ClientId = process.env.REACT_APP_CLIENT_ID;

export const LoginUrl = "Login";
export const LogoutUrl = "Logout";
export const ValidateAccessKey = "ValidateAccessKey";
export const GetOperableFiscalPeriods = "Accounting/OperableFiscalPeriods";
export const LoginFreee = "Freee/Login";
export const GetCompanies = "Freee/Companies";
export const TransferValuesAsync = "Accounting/TransferValuesAsync";
export const TransferStructuresAsync = "Accounting/TransferStructuresAsync";
export const CheckAsyncStatus = "CheckAsyncStatus";
export const TransferValuesResult = "Accounting/TransferValuesResult";
export const TransferStructuresResult = "Accounting/TransferStructuresResult";
export const ExportToCSV = "Accounting/ExportToCSV";
export const WorksIAuthorzation = "worksI-authorzation";
export const FreeeUserInfo= "freee-userinfo";

// Values const
export const CompanySelected = "CompanySelected";
export const FreeeAuthorzation = "freee-authorzation";


